import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { useAuth } from "../../../auth/useAuth";
import { Navigate, useNavigate } from "react-router-dom";
import MicrosoftIcon from "@ui/components/icons/MicrosoftIcon";
import { loginRequest } from "../../../auth/auth-config";
const LoginPageWrapper = ({ children, }) => (React.createElement(Box, { sx: {
        height: "100dvh",
        width: "100vw",
        maxWidth: "100vw",
        backgroundColor: "#00B6ED",
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
    } },
    React.createElement(Box, { component: "img", src: "/assets/images/vdk-logo-login.png", alt: "Logo top left", sx: {
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
            width: { xs: 148, sm: 256, md: "auto" },
        } }),
    React.createElement(Box, { component: "img", src: "/assets/images/vdk-logo-login.png", alt: "Logo bottom right", sx: {
            position: "absolute",
            bottom: 0,
            right: 0,
            zIndex: 0,
            width: { xs: 148, sm: 256, md: "auto" },
            boxSizing: "border-box",
        } }),
    React.createElement(Box, { component: "img", src: "/assets/images/login-bg-diamond.png", alt: "Diamond top right", sx: {
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 0,
            width: { xs: 260, sm: 380, md: "auto" },
            maxWidth: 750,
        } }),
    React.createElement(Box, { component: "img", src: "/assets/images/login-bg-bottom-daimond.png", alt: "Diamond bottom left", sx: {
            position: "absolute",
            bottom: 0,
            left: 0,
            zIndex: 0,
            maxWidth: 800,
            width: { xs: 260, sm: 380, md: "auto" },
        } }),
    React.createElement(Box, { sx: {
            position: "relative",
            zIndex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
        } }, children)));
export const LoginPage = () => {
    const [animate, setAnimate] = useState(false);
    const { isAuthenticated, inProgress } = useAuth();
    const { instance } = useMsal();
    const navigate = useNavigate();
    useEffect(() => {
        if (isAuthenticated) {
            navigate("/project", { replace: true });
        }
    }, [isAuthenticated, navigate]);
    const handleLogin = () => {
        setAnimate(true);
        try {
            sessionStorage.setItem("postLoginRedirect", "/project");
        }
        catch (_a) {
            // ignore: best-effort
        }
        // Trigger Microsoft SSO via MSAL
        // Call after a short delay to let the animation kick in
        setTimeout(() => {
            instance.loginRedirect(loginRequest);
        }, 200);
    };
    // Avoid flicker: if already authenticated, navigate immediately
    if (isAuthenticated) {
        return React.createElement(Navigate, { to: "/project", replace: true });
    }
    // While MSAL is handling redirect or initializing, render nothing
    if (inProgress && inProgress !== "none") {
        return null;
    }
    return (React.createElement(LoginPageWrapper, null,
        React.createElement(Box, { sx: { display: "flex", alignItems: "center", justifyContent: "center" } },
            React.createElement(Box, { sx: {
                    width: { xs: 350, sm: 400, md: 500, lg: 600 },
                    height: { xs: 350, sm: 400, md: 500, lg: 600 },
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    zIndex: 1,
                    transform: animate
                        ? "translate(-50%, -50%) scale(8)"
                        : "translate(-50%, -50%) scale(1)",
                    background: `url('/assets/images/polygon.svg') center/contain no-repeat`,
                    borderRadius: 0,
                    opacity: animate ? 0.3 : 1,
                    transition: "transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
                    overflow: "hidden",
                } }),
            React.createElement(Box, { sx: {
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    zIndex: 2,
                    transform: "translate(-50%, -50%)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    cursor: "pointer",
                    gap: 1,
                    pointerEvents: "auto",
                }, onClick: handleLogin },
                React.createElement(MicrosoftIcon, null),
                React.createElement(Typography, { variant: "h3", sx: {
                        fontWeight: 400,
                        color: "#3192D0",
                    } }, "Inloggen")))));
};
